import { render, staticRenderFns } from "./IbxReportSuccessModal.vue?vue&type=template&id=4d452a7d"
import script from "./IbxReportSuccessModal.vue?vue&type=script&lang=js"
export * from "./IbxReportSuccessModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports